import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

const mutation = graphql`
    mutation updateCampaignMutation($input: updateHyreferralCampaignInput!){
        updateHyreferralCampaign(input:$input) {
          clientMutationId
          hyreferralCampaign {
            id
            propertyId
            title
            reward
            emailSubject
            emailBody
            emailSms
            ctaDesign
            ctaText
            bannerText
            pitchMessage
            residentEnrollHeader
            residentEnrollFooter
            emailEnabled
            smsEnabled
            facebookEnabled
            twitterEnabled
            residentInviteEmailSubject
            residentInviteEmailBody
            residentInviteSms
            residentInviteSocialContent
            residentDiscountEmailSubject
            residentDiscountEmailBody
            residentDiscountEmailSms
            tourCtaText
            tourCtaUrl
            contactCtaText
            contactCtaUrl
            active
            image{
              thumbnailUrl
            }
            residentInviteImage{
              thumbnailUrl
            }
            residentDiscountImage{
              thumbnailUrl
            }
            shortTourCtaUrl
            enrollUrl
            shortEnrollUrl
            propertyName
            rewardEmailHeader
            friendInviteEmailHeader
            friendInviteMenuHeader
            friendInviteMenuBody
            residentBannerTitle
            popupMessage
            popupTitle
            residentInviteCampaignTested
            residentThankYouEmailSubject
            residentThankYouEmailTitle
            residentThankYouEmailBody
            landingPageContent
            residentThankYouImage{
              id
              fileType
              fileSize
              fileUrl
              dimension
              thumbnailUrl
            }
            landingPageTitle
            landingPageImage{
              id
              fileType
              fileSize
              fileUrl
              dimension
              thumbnailUrl
            }
            emailValidationStatus
          }
        }
    }`;


function commit(environment, input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      updater: (store) => {

      },
      onCompleted: res,
      onError: rej
    })
  });
}

export default commit;